import React from "react";
import { Paper, Stack, Typography, Divider } from "@mui/material";
import ActivityGroupCard from "../cards/ActivityGroupCard";

export default function ActivityGroupsPanel({
  selectedCampusName,
  selectedCampusLabel,
  selectedSlot,
  groups = [],
  leaders = [],
  products = [],
  onEditGroup,
  onDeleteGroup,
  onSaveMembers,
  journeys,
  onAssignMembersToBus,
  onSplitGroup,
}) {
  return (
    <Paper variant="outlined" sx={{ p: 2, height: "100%" }}>
      <Stack spacing={1}>
        <Stack spacing={0.5}>
          <Typography fontWeight={800}>
            Activity Groups {selectedCampusName ? `• ${selectedCampusLabel}` : ""}
          </Typography>

          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            {selectedSlot}
            {selectedCampusName ? ` • ${groups.length} group${groups.length === 1 ? "" : "s"}` : ""}
          </Typography>
        </Stack>

        <Divider />

        {!selectedCampusName ? (
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            Pick a campus to show activity groups.
          </Typography>
        ) : groups.length === 0 ? (
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            No activity groups for this selection.
          </Typography>
        ) : (
          <Stack spacing={2}>
            {groups.map((group) => (
              <ActivityGroupCard
                key={`activity-group-${group.groupId}`}
                group={group}
                leaders={leaders}
                products={products}
                onEdit={() => onEditGroup(group)}
                onDelete={onDeleteGroup}
                onSaveMembers={onSaveMembers}
                journeys={journeys}
                onAssignMembersToBus={onAssignMembersToBus}
                onSplitGroup={onSplitGroup}
              />
            ))}
          </Stack>
        )}
      </Stack>
    </Paper>
  );
}